import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "custom-mat-table-sort-icon",
  template: ` <img
      [src]="'../../assets/images/sort_inactive.svg'"
      *ngIf="sortDirection == '' || (activeColumn && activeColumn != column)"
      class="sort-image"
      alt="Sorting neutral"
    />
    <img
      [src]="'../../assets/images/sort_down.svg'"
      *ngIf="sortDirection == 'desc' && activeColumn && activeColumn == column"
      class="sort-image"
      alt="Sorting descending"
    />
    <img
      [src]="'../../assets/images/sort_up.svg'"
      *ngIf="sortDirection == 'asc' && activeColumn && activeColumn == column"
      class="sort-image"
      alt="Sorting ascending"
    />`,
  styleUrls: ["./custom-mat-table-sort-icon.component.scss"],
})
export class CustomMatTableSortIconComponent implements OnInit {
  @Input() sortDirection;
  @Input() activeColumn;
  @Input() column;

  constructor() {}

  ngOnInit() {}
}
